import moment from 'moment';

export default date => {
  return moment().diff(date, 'years') >= 18;
};
